import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TauiBottomSheetModalService } from '@ngx-tailwind-ui/bottom-sheet-modal';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'webmodule-order-modal',
  imports: [CommonModule, TranslatePipe],
  styles: [],
  templateUrl: './modal-content.component.html',
  standalone: true,
})
export class ModalContentComponent {
  private readonly bottomSheetModalService = inject(TauiBottomSheetModalService);
  title = input<string>('');
  description = input<string>('');

  close() {
    this.bottomSheetModalService.closeBottomSheet();
  }
}
